export const BOOTSTRAP_ICONS = [
  { name: 'folder', label: 'Folder', category: 'general' },
  { name: 'folder-fill', label: 'Folder Fill', category: 'general' },
  { name: 'file-earmark', label: 'File', category: 'general' },
  { name: 'archive', label: 'Archive', category: 'general' },
  { name: 'box', label: 'Box', category: 'general' },
  { name: 'briefcase', label: 'Briefcase', category: 'general' },
  { name: 'clipboard', label: 'Clipboard', category: 'general' },
  { name: 'list-task', label: 'Task List', category: 'general' },
  { name: 'book', label: 'Book', category: 'education' },
  { name: 'book-fill', label: 'Book Fill', category: 'education' },
  { name: 'mortarboard', label: 'Graduation Cap', category: 'education' },
  { name: 'pencil', label: 'Pencil', category: 'education' },
  { name: 'pen', label: 'Pen', category: 'education' },
  { name: 'journal-text', label: 'Journal', category: 'education' },
  { name: 'calculator', label: 'Calculator', category: 'education' },
  { name: 'globe', label: 'Globe', category: 'education' },
  { name: 'map', label: 'Map', category: 'education' },
  { name: 'award', label: 'Award', category: 'education' },
  { name: 'trophy', label: 'Trophy', category: 'education' },
  { name: 'heart', label: 'Heart', category: 'healthcare' },
  { name: 'heart-fill', label: 'Heart Fill', category: 'healthcare' },
  { name: 'bandaid', label: 'Band-Aid', category: 'healthcare' },
  { name: 'capsule', label: 'Capsule', category: 'healthcare' },
  { name: 'hospital', label: 'Hospital', category: 'healthcare' },
  { name: 'currency-dollar', label: 'Dollar', category: 'finance' },
  { name: 'credit-card', label: 'Credit Card', category: 'finance' },
  { name: 'bank', label: 'Bank', category: 'finance' },
  { name: 'wallet', label: 'Wallet', category: 'finance' },
  { name: 'coin', label: 'Coin', category: 'finance' },
  { name: 'gear', label: 'Gear', category: 'manufacturing' },
  { name: 'gear-fill', label: 'Gear Fill', category: 'manufacturing' },
  { name: 'tools', label: 'Tools', category: 'manufacturing' },
  { name: 'laptop', label: 'Laptop', category: 'technology' },
  { name: 'phone', label: 'Phone', category: 'technology' },
  { name: 'code-slash', label: 'Code', category: 'technology' },
  { name: 'house', label: 'House', category: 'hospitality' },
  { name: 'building', label: 'Building', category: 'hospitality' },
  { name: 'cup', label: 'Cup', category: 'food' },
  { name: 'trophy', label: 'Trophy', category: 'sports' },
  { name: 'shield', label: 'Shield', category: 'security' },
  { name: 'lock', label: 'Lock', category: 'security' },
  { name: 'chat', label: 'Chat', category: 'communication' },
  { name: 'clock', label: 'Clock', category: 'time' },
  { name: 'calendar', label: 'Calendar', category: 'time' },
];

export const COLOR_PRESETS = [
  '#3b82f6', '#1a237e', '#7c3aed', '#dc2626', '#ea580c', 
  '#059669', '#0891b2', '#be185d'
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low Priority' },
  { value: 'medium', label: 'Medium Priority' },
  { value: 'high', label: 'High Priority' },
  { value: 'critical', label: 'Critical Priority' }
];

